import {jsx} from 'panel';
import {VNode} from 'snabbdom';

import {ControlBarEl} from 'common/widgets/control-bar';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme, ButtonType} from 'common/components/button/constants';
import {Placement} from 'common/components/tooltip/types';

import type {QueryEntrySection} from '../index';
import {Action, QueryMetricEntry, QuerySuperEntry} from '../types';
import {ControlBarAction} from '../constants';

export function RowActions({
  el,
  index,
  entry,
  actionsRenderer = null,
}: {
  el: QueryEntrySection;
  entry: QuerySuperEntry;
  index: number;
  actionsRenderer?: () => VNode | null;
}) {
  const hasNewUI = el.hasNewQBUI();
  const isBehavior = el.helpers.hasBehavioralFrequencyFilter(entry as QueryMetricEntry);
  const overflowControls = el.helpers.getEntryOverflowControls(index);
  const isEmptyPlaceholder = el.isEmptyPlaceholder(index, entry);

  const controls = overflowControls.map((section) => section.items).flat();
  const isDeleteOnly = controls.length === 1 && controls[0].value?.action === ControlBarAction.Delete;
  const showOverflowMenu = controls.length > 0 && !isDeleteOnly;

  const deleteButton = (
    <ButtonEl
      key='entry-delete-action'
      attrs={{
        elref: `deleteLineButton`,
        theme: ButtonTheme.Tertiary,
        icon: hasNewUI ? `x` : `trashcan`,
        role: `button`,
        disabled: el.attr(`disabled`),
        type: ButtonType.Destructive,
        tooltip: {
          text: `Remove`,
          placement: Placement.Top,
        },
      }}
      on={{
        click: () => el.helpers.onEventActionClick(Action.Remove, index),
      }}
    />
  );

  return (
    <div sel='.mp-query-entry-actions'>
      {actionsRenderer && actionsRenderer()}

      {/** row delete button */}
      {el.helpers.canDeleteEntry() && !isBehavior && hasNewUI && !isEmptyPlaceholder && deleteButton}

      {!el.helpers.hasBehavioralFrequencyFilter(entry as QueryMetricEntry) && (
        <div sel='.mp-query-control-bar-container'>
          {showOverflowMenu && (
            <ControlBarEl
              key='entry-actions'
              attrs={{
                elref: `lineActions`,
                theme: ButtonTheme.Tertiary,
                'overflow-icon': hasNewUI ? `ellipsis` : `hor-ellipsis`,
                'overflow-controls': overflowControls,
                'overflow-menu-width': 200,
                'overflow-menu-height': 330,
                disabled: el.attr(`disabled`),
              }}
              on={{
                select: (ev: CustomEvent) => el.helpers.onControlSelect(ev.detail.value, index),
              }}
              props={{
                contextPanelTransform: el.helpers.overflowControlsContextPanelTransform,
              }}
            />
          )}
        </div>
      )}

      {/** row delete button */}
      {el.helpers.canDeleteEntry() && !isBehavior && !hasNewUI && !isEmptyPlaceholder && deleteButton}
    </div>
  );
}
